module.exports = __webpack_public_path__ + "img/readMsgStatus.a3bca9f4.svg";